import React, {Component} from 'react';
import {connect} from 'react-redux'
import {compose} from 'redux'
import {withRouter} from 'react-router-dom'
import {Box} from 'reactjs-admin-lte'
import {Button,Row,Col,FormControl} from 'react-bootstrap'
import Select from 'react-select';
import FontAwsome from 'react-fontawesome'
// import { Checkbox } from 'react-icheck';
import WorkdocStore from '../../stores/WorkdocStore';
import './WorkDoc.css';
import fuelgauge from '../../asset/img/fuelgauge3-150.png';
import carbody from '../../asset/img/carbody3.jpg';
import _ from 'lodash'
import RowItem from '../settings/Menu10/RowItem'
import SWTNewCarTypeButton from './SWTNewCarTypeButton'
// import Masonry from 'react-masonry-component';
var NotificationSystem = require('react-notification-system');
class WorkDocCheckCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      dataCarbody:[],
      
      car_options:[],
      data:{car_type_options:{},checkcar:{asset:[],asset_inside:[],asset_trunk:[],car_src_img:null,car_type:'ANY',codelist:[],checkcode:[],damage:[],system:[],system_other:'',all_remark:''}},
      checkcodedot:{class:'none',select:0}
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    this.loadCarType()
  }

  renderLabelCarType(label,value) {
    return(<span><img src={'https://static.bigfix.co/img/'+value+'-32x32.png'}/>{label}</span>)
  }

  loadCarType(car_type='') {
    let car_options = []
    WorkdocStore.loadConfigCheckcar(car_type,(result)=>{
      car_options = result.data.car_type_options.map((item,index)=>{
        return {label:this.renderLabelCarType(item.name,item.value),value:item.value}
      })
      let data = result.data
      data = Object.assign({img_body:{fuel:{x:'',y:''}}}, data)
      data.checkcar = Object.assign({car_type:this.state.data.checkcar.car_type}, data.checkcar)
      this.setState({car_options:car_options,data:data})
      this.setImgBody()
    })
  }

  setFuelgauge() {
    let {dataCarbody} = this.state
    if (this.canvasFuelgauge!==null) {
      const contextFuelgauge = this.canvasFuelgauge.getContext('2d')
      const imageFuelgauge = new Image()
      imageFuelgauge.src = fuelgauge
      imageFuelgauge.onload = () => {
        contextFuelgauge.drawImage(imageFuelgauge, 0, 0, this.canvasFuelgauge.width, this.canvasFuelgauge.height)
        if ((dataCarbody&&dataCarbody.length>0)||(dataCarbody.length===undefined)) {  
          this.setDrawLine()
        }
      }
    }  
  }

  setDrawLine() {
    let {dataCarbody} = this.state
    if (this.canvasFuelgauge!==null) {
      const context = this.canvasFuelgauge.getContext('2d')
      const imageFuelgauge = new Image()
      imageFuelgauge.src = fuelgauge
      context.drawImage(imageFuelgauge, 0, 0, 100, 50);

      var x = dataCarbody.fuel['x']
      var y = dataCarbody.fuel['y']
      if (x!==""&&y!=="") {
        context.beginPath();
        context.moveTo(x, y);
        context.lineTo(50, 50);
        context.lineWidth = 5;

        context.strokeStyle = '#ff0000';
        context.stroke();
      }
    }     
  }

  drawLine(e) {
    let {data} = this.state
    if (this.canvasFuelgauge!==null) {
      const context = this.canvasFuelgauge.getContext('2d')
      const imageFuelgauge = new Image()
      imageFuelgauge.src = fuelgauge
      context.drawImage(imageFuelgauge, 0, 0, 100, 50);

      var r = this.canvasFuelgauge.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;

      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(50, 50);
      context.lineWidth = 5;

      context.strokeStyle = '#ff0000';
      context.stroke();

      data.img_body.fuel['x'] = x
      data.img_body.fuel['y'] = y
      this.setState({data:data})
    }  
  }

  setImgBody() {
    let that = this
    let {dataCarbody} = this.state
    WorkdocStore.loadWorkDocImgBody(that.props.workNo,function(result) {
      if (result.length===0) {
        dataCarbody = {fuel:{x:result.result.fuel.x,y:result.result.fuel.y},point:[]}
      }
      that.setState({dataCarbody:dataCarbody})
      that.setFuelgauge()
      that.setCarbody()
    }) 
  }

  renderCarUrl(car){
    let imgUrl = ''
    if (process.env.NODE_ENV === "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/'+car
    }else{
      imgUrl = '../'+car
    }
    return imgUrl
  }

  setCarbody() {
    let {dataCarbody,data} = this.state
    if (this.canvasCarbody!==null) {
      const contextCarbody = this.canvasCarbody.getContext('2d')
      const imageCarbody = new Image()
      imageCarbody.src = data.checkcar.car_src_img!==null?this.renderCarUrl(data.checkcar.car_src_img):carbody

      // if (dataCarbody.img!="") {
      //   let path = "'"+dataCarbody.img+"'"
      //   imageCarbody.src = require(path)
      // } else { 
      //   imageCarbody.src = require('../../asset/img/carbody3.jpg')
      // }

      imageCarbody.onload = () => {
        contextCarbody.drawImage(imageCarbody, 0, 0, this.canvasCarbody.width, this.canvasCarbody.height)
        if ((dataCarbody&&dataCarbody.length>0)||(dataCarbody.length===undefined)) {  
          this.setDrawPoint()
        }
      }
    }  
  }

  setDrawPoint() { 
    let {dataCarbody,data} = this.state
    if (this.canvasCarbody!==null) {
      const context = this.canvasCarbody.getContext('2d')
      const imageCarbody = new Image()
      imageCarbody.src = data.checkcar.car_src_img!==null?this.renderCarUrl(data.checkcar.car_src_img):carbody

      dataCarbody.point.forEach(element => {
        var x = element.x;
        var y = element.y;

        var text = element.text
        if (text !== '') {
          this.draw_text(context, text, x, y);
          if (typeof imageCarbody.point === 'undefined') {
            imageCarbody.point = [];
          }
          var new_draw = {text: text, x: x, y: y};
          imageCarbody.point.push(new_draw);
        }
      })  
    }  
  }

  drawPoint(e) {
    let {checkcodedot,data} = this.state
    if (checkcodedot.class==='active') {
      if (this.canvasCarbody!==null) {
        const context = this.canvasCarbody.getContext('2d')
        const imageCarbody = new Image()
        imageCarbody.src = data.checkcar.car_src_img!==null?this.renderCarUrl(data.checkcar.car_src_img):carbody
        var r = this.canvasCarbody.getBoundingClientRect();

        var x = e.clientX - r.left;
        var y = e.clientY - r.top;

        var text = (checkcodedot.select*1)+1
        if (text !== '') {
          if (data.img_body.point) {
            data.img_body.point.push({
              text:text,
              x:x,
              y:y
            })
          } else {
            let point = []
            point.push({
              text:text,
              x:x,
              y:y
            })
            data.img_body['point'] = point
          }
          
          this.setState({data:data})
          this.draw_text(context, text, x, y);
          if (typeof imageCarbody.point === 'undefined') {
            imageCarbody.point = [];
          }
          var new_draw = {text: text, x: x, y: y};
          imageCarbody.point.push(new_draw);
        }
      }  
    }  
  }

  draw_text(context, text, x, y) {
    x *= 1;
    y *= 1;
    context.beginPath();
    context.arc(x, y, 10, 0, 2 * Math.PI, false);
    context.fillStyle = 'green';
    context.fill();
    context.lineWidth = 2;
    context.strokeStyle = '#003300';
    context.stroke();

    context.lineWidth = 1;
    context.fillStyle = "#FF0000";
    context.lineStyle = "#ffff00";
    context.font = "bold 22px sans-serif";
    context.fillText(text, x - 6, y + 8);
  }

  onClearPointClick(e) {
    let {data} = this.state
    if (this.canvasCarbody!==null) {
      const contextCarbody = this.canvasCarbody.getContext('2d')
      const imageCarbody = new Image()
      imageCarbody.src = data.checkcar.car_src_img!==null?this.renderCarUrl(data.checkcar.car_src_img):carbody
      imageCarbody.onload = () => {
        contextCarbody.drawImage(imageCarbody, 0, 0, this.canvasCarbody.width, this.canvasCarbody.height)
      }
      data.img_body.point = []
      this.setState({data:data})
    }  
  }

  onCheckCodeClick(index,e) {
    let {checkcodedot} = this.state
    checkcodedot.select = index
    checkcodedot.class = 'active'
    this.setState({checkcodedot:checkcodedot})
  }

  getBgTr(index) {
    let {checkcodedot} = this.state
    if (checkcodedot.class==='active') {
      if (checkcodedot.select===index) {
        return 'bg-green'
      }
    }
  }

  renderFuelgauge() {
    return(
      <div>
        {this.props.messages['Fuel']}   
        <div><img alt='' src={fuelgauge} width="100px" style={{display:'none'}} /></div> 
        <canvas
          onClick={this.drawLine.bind(this)}
          ref={canvasFuelgauge => this.canvasFuelgauge = canvasFuelgauge}
          width="100" height="50">
          <p>Error</p>
        </canvas>
      </div>
    )
  }

  renderCheckOut() {
    return(
      <div>
        <table className='table table-bordered table-workdoc-check-car'>
          <thead>
            <tr>
              <th className="text-center">
                {this.props.messages['Check Outside']}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">
                <canvas
                  onClick={this.drawPoint.bind(this)}
                  ref={canvasCarbody => this.canvasCarbody = canvasCarbody}
                  width="428" height="300">
                  <p>Error</p>
                </canvas>
              </td>
            </tr>
          </tbody>
        </table>    
      </div>
    )
  }

  renderCheckCode() {
    return(
      <div>
        <table className='table table-workdoc-check-car' style={{border:'1px solid #ddd'}}>
          <thead>
            <tr>
              <th colSpan={3}>
                {this.props.messages['Check Code']} <span onClick={this.onCheckcodeAdd.bind(this)} className='pull-right' style={{cursor:'pointer'}}><FontAwsome name='plus' /></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderCheckCodeData()}
            <tr>
              <td className='text-center' colSpan={3}><Button bsStyle='danger' bsSize='xs' onClick={this.onClearPointClick.bind(this)}><FontAwsome name='trash' /> {this.props.messages['Delete Point']}</Button></td>
            </tr>
          </tbody>
        </table>    
      </div>
    )
  }

  renderCheckCodeData() {
    let {data} = this.state
    if (data.checkcar.checkcode === undefined) {   
      return(<tr><td>{this.props.messages['Data Not Found']}</td></tr>)
    } else { 
      return(
        data.checkcar.checkcode.map((item, index) => {
          return <RowItem 
            key={index} 
            id={'checkcode'+item.item_id}
            seq={item.item_id}
            item={item}
            moveRow={this.onMoveRow.bind(this,'checkcode')}
            renderColDetail={this.renderColDetail.bind(this,'checkcode',index)}
            getBgTr={this.getBgTr.bind(this)}
          />
        })
      )
    }
  }

  onMoveRow(field,id,afterId) {
    let {data} = this.state
    var rows = _.clone(data.checkcar[field]);
    var currentRow = _.filter(rows, function (r) { return field+r.item_id === id; })[0];
    var afterRow = _.filter(rows, function (r) { return field+r.item_id === afterId; })[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data.checkcar[field] = rows
    this.setState({data: data});
  }

  onCheckcodeAdd() {
    let {data} = this.state
    data.checkcar.checkcode = data.checkcar.checkcode.concat({car_type:'',description:'',description_en:'',item_id:((data.checkcar.checkcode.length+1).toString()),item_key:'CHECKCODE',item_value:''})
    this.setState({data:data})
  }

  onDamageAdd() {
    let {data} = this.state
    data.checkcar.damage = data.checkcar.damage.concat({car_type:'',description:'',description_en:'',item_id:((data.checkcar.damage.length+1).toString()),item_key:'DAMAGELIST',item_value:''})
    this.setState({data:data})
  }

  onSystemAdd() {
    let {data} = this.state
    data.checkcar.system = data.checkcar.system.concat({car_type:'',description:'',description_en:'',item_id:((data.checkcar.system.length+1).toString()),item_key:'SYSTEM',item_value:''})
    this.setState({data:data})
  }

  onAssetInsideAdd() {
    let {data} = this.state
    data.checkcar.asset_inside = data.checkcar.asset_inside.concat({car_type:'',description:'',description_en:'',item_id:((data.checkcar.asset_inside.length+1).toString()),item_key:'ASSET_INSIDE',item_value:''})
    this.setState({data:data})
  }

  onAssetTrunkAdd() {
    let {data} = this.state
    data.checkcar.asset_trunk = data.checkcar.asset_trunk.concat({car_type:'',description:'',description_en:'',item_id:((data.checkcar.asset_trunk.length+1).toString()),item_key:'ASSET_TRUNK',item_value:''})
    this.setState({data:data})
  }

  onCheckcodeDel(index) {
    let {data} = this.state
    data.checkcar.checkcode.splice(index,1)
    this.setState({data:data})
  }

  onDamgeDel(index) {
    let {data} = this.state
    data.checkcar.damage.splice(index,1)
    this.setState({data:data})
  }

  onSystemDel(index) {
    let {data} = this.state
    data.checkcar.system.splice(index,1)
    this.setState({data:data})
  }

  onAssetInsideDel(index) {
    let {data} = this.state
    data.checkcar.asset_inside.splice(index,1)
    this.setState({data:data})
  }

  onAssetTrunkDel(index) {
    let {data} = this.state
    data.checkcar.asset_trunk.splice(index,1)
    this.setState({data:data})
  }

  onCheckcodeChange(field,index,e) {
    let {data} = this.state
    data.checkcar.checkcode[index][field] = e.target.value
    this.setState({data:data})
  }

  onDamageChange(field,index,e) {
    let {data} = this.state
    data.checkcar.damage[index][field] = e.target.value
    this.setState({data:data})
  }

  onSystemChange(field,index,e) {
    let {data} = this.state
    data.checkcar.system[index][field] = e.target.value
    this.setState({data:data})
  }

  onAssetInsideChange(field,index,e) {
    let {data} = this.state
    data.checkcar.asset_inside[index][field] = e.target.value
    this.setState({data:data})
  }

  onAssetTrunkChange(field,index,e) {
    let {data} = this.state
    data.checkcar.asset_trunk[index][field] = e.target.value
    this.setState({data:data})
  }

  renderColDetail(field,index,item) {
    let {data} = this.state
    if (field==='checkcode') {
      return([
        <td key={0} className='tetx-center' style={{width:'20px',verticalAlign:'middle'}}><FontAwsome name='bars' /></td>,
        <td key={1} onClick={this.onCheckCodeClick.bind(this,data.checkcar[field][index].item_id)}>
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].description}
            onChange={this.onCheckcodeChange.bind(this,'description',index)}
          />
        </td>,
        <td key={2} style={{width:'20px',verticalAlign:'middle'}} className='tetx-center'><Button onClick={this.onCheckcodeDel.bind(this,index)} bsSize='xs' bsStyle='danger'><FontAwsome name='trash' /></Button></td>
      ])
    } else if (field==='damage') {
      return([
        <td key={0} className='tetx-center' style={{width:'20px',verticalAlign:'middle'}}><FontAwsome name='bars' /></td>,
        <td key={1}>
          {/* 
          <div style={{display:'flex'}}>
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label=''
              checked={this.getCheckRepairOrder(data.checkcar[field][index])}
              onChange={this.onRepairOrderChange.bind(this,data.checkcar[field][index],data.checkcar[field][index].item_id,index)}
            >
            </Checkbox>
            &nbsp;
            <FormControl 
              style={{width:'100px'}}
              className="input-gen-doc" 
              type="text" 
              value={data.checkcar[field][index].description}
              onChange={this.onDamageChange.bind(this,'description',index)}
            />
          </div> 
          */}
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].description}
            onChange={this.onDamageChange.bind(this,'description',index)}
          />
        </td>,
        <td key={2} style={{width:'20px',verticalAlign:'middle'}} className='tetx-center'><Button onClick={this.onDamgeDel.bind(this,index)} bsSize='xs' bsStyle='danger'><FontAwsome name='trash' /></Button></td>
      ])
    } else if (field==='system') {
      return([
        <td key={0} className='tetx-center' style={{width:'20px',verticalAlign:'middle'}}><FontAwsome name='bars' /></td>,
        <td key={1}>
          {/*
          <div style={{display:'flex'}}>
            <Checkbox
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label=''
              checked={this.getCheckSystem(data.checkcar[field][index])}
              onChange={this.onCheckSystemChange.bind(this,data.checkcar[field][index],data.checkcar[field][index].item_id,index)}
            >
            </Checkbox>
            &nbsp;
            <FormControl 
              style={{width:'100px'}}
              className="input-gen-doc" 
              type="text" 
              value={data.checkcar[field][index].description}
              onChange={this.onSystemChange.bind(this,'description',index)}
            />
          </div>
          */}
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].description}
            onChange={this.onSystemChange.bind(this,'description',index)}
          />
        </td>,
        <td key={2} style={{width:'20px',verticalAlign:'middle'}} className='tetx-center'><Button onClick={this.onSystemDel.bind(this,index)} bsSize='xs' bsStyle='danger'><FontAwsome name='trash' /></Button></td>
      ])
    } else if (field==='asset_inside') {
      return([
        <td key={0} className='tetx-center' style={{verticalAlign:'middle',borderRight:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}><FontAwsome name='bars' /></td>,
        <td key={1} style={{padding:'0',verticalAlign:'middle',borderRight:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}>
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].description}
            onChange={this.onAssetInsideChange.bind(this,'description',index)}
          />
        </td>,
        <td key={2} style={{padding:'0',verticalAlign:'middle',borderRight:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}>
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].item_value}
            onChange={this.onAssetInsideChange.bind(this,'item_value',index)}
          />
        </td>,
        <td key={3} style={{width:'20px',verticalAlign:'middle',borderRight:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}} className='tetx-center'><Button onClick={this.onAssetInsideDel.bind(this,index)} bsSize='xs' bsStyle='danger'><FontAwsome name='trash' /></Button></td>
      ])
    } else if (field==='asset_trunk') {
      return([
        <td key={0} className='tetx-center' style={{verticalAlign:'middle',borderLeft:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}><FontAwsome name='bars' /></td>,
        <td key={1} style={{padding:'0',verticalAlign:'middle',borderLeft:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}>
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].description}
            onChange={this.onAssetTrunkChange.bind(this,'description',index)}
          />
        </td>,
        <td key={2} style={{padding:'0',verticalAlign:'middle',borderLeft:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}}>
          <FormControl 
            className="input-gen-doc" 
            type="text" 
            value={data.checkcar[field][index].item_value}
            onChange={this.onAssetTrunkChange.bind(this,'item_value',index)}
          />
        </td>,
        <td key={3} style={{width:'20px',verticalAlign:'middle',borderLeft:'1px solid #ddd',borderBottom:(index===data.checkcar[field].length-1?'1px solid #ddd':'none')}} className='tetx-center'><Button onClick={this.onAssetTrunkDel.bind(this,index)} bsSize='xs' bsStyle='danger'><FontAwsome name='trash' /></Button></td>
      ])
    }
  }

  onSystemOtherChange(e) {
    let {data} = this.state
    data.checkcar.system_other = e.target.value
    this.setState({data:data})
  }

  renderRepairOrder() {
    return(
      <div>
        <table className='table table-workdoc-check-car' style={{border:'1px solid #ddd'}}>
          <thead>
            <tr>
              <th colSpan={3}>
                {this.props.messages['Repair Order']} <span onClick={this.onDamageAdd.bind(this)} className='pull-right' style={{cursor:'pointer'}}><FontAwsome name='plus' /></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRepairOrderData()}
            <tr>
              <td colSpan={3} style={{padding:'0'}}>
                <textarea 
                  style={{width:'100%', height:'200px'}}
                  value={this.state.data.checkcar.system_other}
                  onChange={this.onSystemOtherChange.bind(this)}
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>    
      </div>
    )
  }

  getCheckRepairOrder(item) {
    if (item.item_value===1) {
      return true
    }
  }

  onRepairOrderChange(item,item_id,index,e) {
    let {data} = this.state
    data.checkcar.damage.forEach(element => {
      if (item_id===element.item_id) {
        if (data.checkcar.damage[index].item_value===1) {
          data.checkcar.damage[index].item_value = 0
        } else {
          data.checkcar.damage[index].item_value = 1
        }
      }
    })
    this.setState({data:data})
  }

  renderRepairOrderData() {
    let {data} = this.state
    if (data.checkcar.damage.length === 0) {   
      return(<tr><td>{this.props.messages['Data Not Found']}</td></tr>)
    } else { 
      return(
        data.checkcar.damage.map((item, index) => {
          return <RowItem 
            key={index} 
            id={'damage'+item.item_id}
            seq={item.item_id} 
            item={item}
            moveRow={this.onMoveRow.bind(this,'damage')}
            renderColDetail={this.renderColDetail.bind(this,'damage',index)}
          />  
        })
      )
    }
  }

  renderAsset() {
    let {messages} = this.props
    return(
      <div>
        <table className='table' style={{border:'1px solid #ddd'}}>
          <thead>
            <tr>
              <th colSpan={8} style={{textAlign:'center',backgroundColor:'#5d7b9d',color:'#fff'}}>
                {messages['Item List']}
              </th>
            </tr>
            <tr>
              <th colSpan={4} style={{textAlign:'center',verticalAlign:'top',padding:'0',borderBottom:'none'}}>
                <table className='table table-workdoc-check-car'>
                  <thead>
                    <tr>
                      <th style={{textAlign:'center',width:'20px',minWidth:'20px',borderRight:'1px solid #ddd'}}>
                        
                      </th>
                      <th style={{textAlign:'center',width:'200px',minWidth:'200px',borderRight:'1px solid #ddd'}}>
                        {messages['Inside Cabin']}
                      </th>
                      <th style={{textAlign:'center',width:'80px',minWidth:'80px',borderRight:'1px solid #ddd'}}>
                        {messages['Quantity']}
                      </th>
                      <th style={{textAlign:'center',width:'20px',minWidth:'20px',borderRight:'1px solid #ddd'}}>
                        <span onClick={this.onAssetInsideAdd.bind(this)} style={{cursor:'pointer'}}><FontAwsome name='plus' /></span>
                      </th>
                    </tr>  
                  </thead>  
                  <tbody>
                    {this.renderAssetInsideData()}
                  </tbody>
                </table>    
              </th>
              <th colSpan={4} style={{textAlign:'center',verticalAlign:'top',padding:'0',borderBottom:'none'}}>
                <table className='table table-workdoc-check-car'>
                  <thead>
                    <tr>
                      <th style={{textAlign:'center',width:'20px',minWidth:'20px',borderRight:'1px solid #ddd'}}>
                        
                      </th>
                      <th style={{textAlign:'center',width:'200px',minWidth:'200px',borderRight:'1px solid #ddd'}}>
                        {messages['Inside Hood']}
                      </th>
                      <th style={{textAlign:'center',width:'80px',minWidth:'80px',borderRight:'1px solid #ddd'}}>
                        {messages['Have/Quantity']}
                      </th>
                      <th style={{textAlign:'center',width:'20px',minWidth:'20px',borderRight:'1px solid #ddd'}}>
                        <span onClick={this.onAssetTrunkAdd.bind(this)} style={{cursor:'pointer'}}><FontAwsome name='plus' /></span>
                      </th>
                    </tr>  
                  </thead>  
                  <tbody>
                    {this.renderAssetTrunkData()}
                  </tbody>
                </table>    
              </th>
            </tr>
          </thead>
        </table>    
      </div>
    )
  }

  renderAssetInsideData() {
    let {data} = this.state
    if (data.checkcar.asset_inside === undefined) {   
      return(<tr><td colSpan={4}>{this.props.messages['Data Not Found']}</td></tr>)
    } else {
      return(
        data.checkcar.asset_inside.map((item, index) => {
          return(
            <RowItem 
              key={index} 
              id={'asset_inside'+item.item_id}
              seq={index}
              item={item}
              moveRow={this.onMoveRow.bind(this,'asset_inside')}
              renderColDetail={this.renderColDetail.bind(this,'asset_inside',index)}
            />
          )  
        })
      )
    }
  }

  renderAssetTrunkData() {
    let {data} = this.state
    if (data.checkcar.asset_trunk === undefined) {   
      return(<tr><td colSpan={4}>{this.props.messages['Data Not Found']}</td></tr>)
    } else {
      return(
        data.checkcar.asset_trunk.map((item, index) => {
          return(
            <RowItem 
              key={index} 
              id={'asset_trunk'+item.item_id}
              seq={index}
              item={item}
              moveRow={this.onMoveRow.bind(this,'asset_trunk')}
              renderColDetail={this.renderColDetail.bind(this,'asset_trunk',index)}
            />
          )  
        })
      )
    }
  }

  onAssetChange(field,index,e) {
    let {data} = this.state
    data.checkcar.asset[index][field] = e.target.value
    this.setState({data:data})
  }

  getCheckSystem(item) {
    if (item.item_value===1) {
      return true
    }
  }

  onCheckSystemChange(item,item_id,index,e) {
    let {data} = this.state
    data.checkcar.system.forEach(element => {
      if (item_id===element.item_id) {
        if (data.checkcar.system[index].item_value===1) {
          data.checkcar.system[index].item_value = 0
        } else {
          data.checkcar.system[index].item_value = 1
        }
      }
    })
    this.setState({data:data})
  }

  renderCheckSystemData() {
    let {data} = this.state
    if (data.checkcar.system === undefined) {   
      return(<tr><td>{this.props.messages['Data Not Found']}</td></tr>)
    } else {
      return(
        data.checkcar.system.map((item, index) => {
          return <RowItem 
            key={index} 
            id={'system'+item.item_id}
            seq={item.item_id} 
            item={item}
            moveRow={this.onMoveRow.bind(this,'system')}
            renderColDetail={this.renderColDetail.bind(this,'system',index)}
          /> 
        })
      )
    }  
  }

  renderCheckSystem() {
    return(
      <div>
        <table className='table table-workdoc-check-car' style={{border:'1px solid #ddd'}}>
          <thead>
            <tr>
              <th colSpan={3}>
                {this.props.messages['Check System']} <span onClick={this.onSystemAdd.bind(this)} className='pull-right' style={{cursor:'pointer'}}><FontAwsome name='plus' /></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderCheckSystemData()}
          </tbody>
        </table>    
      </div>
    )
  }

  onNoteChange(e) {
    let {data} = this.state
    data.checkcar.all_remark = e.target.value
    this.setState({data:data})
  }

  renderNote() {
    return(
      <div>
        <table className='table table-bordered table-workdoc-check-car'>
          <thead>
            <tr>
              <th>
                {this.props.messages['Note']}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{padding:'0'}}>
                <textarea 
                  style={{width:'100%', height:'300px'}}
                  value={this.state.data.checkcar.all_remark}
                  onChange={this.onNoteChange.bind(this)}
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>    
      </div>
    )
  }

  sortItem(checkcar) {
    checkcar.checkcode = checkcar.checkcode.map((item,index)=>{
      item.item_id = (index+1).toString()
      return item
    })
    checkcar.damage = checkcar.damage.map((item,index)=>{
      item.item_id = (index+1).toString()
      return item
    })
    checkcar.system = checkcar.system.map((item,index)=>{
      item.item_id = (index+1).toString()
      return item
    })
    checkcar.asset_inside = checkcar.asset_inside.map((item,index)=>{
      item.item_id = (index+1).toString()
      return item
    })
    checkcar.asset_trunk = checkcar.asset_trunk.map((item,index)=>{
      item.item_id = (index+1).toString()
      return item
    })
    return checkcar
  }

  onSaveClick(e) {
    let that = this
    let {data} = this.state
    let newData = this.sortItem(data.checkcar)
    let postData = {checkcar:newData}
    WorkdocStore.saveConfigCheckcar(postData,function(result) {
      if (result.status==="OK") {
        that._notificationSystem.addNotification({
          title:that.props.messages['Notification'],
          message:that.props.messages['Save Successfully'],
          level:'info',
          position:'tc'
        })
      }
    },function(){
      that._notificationSystem.addNotification({
        title:that.props.messages['Notification'],
        message:that.props.messages['Save Failed'],
        level:'error',
        position:'tc'
      })
    })
  }

  onCarTypeChange(e) {
    let {data} = this.state
    if (e!==null) {
      data.checkcar.car_type = e.value
      this.setState({data:data})
      this.loadCarType(e.value)
    } else {
      data.checkcar.car_type = 'ANY'
      this.setState({data:data})
      this.loadCarType('ANY')
    }
  }

  onReloadCarType() {
    this.loadCarType(this.state.data.checkcar.car_type)
  }

  renderDropDownCarType() {
    let {data,car_options} = this.state
    return(
      <div style={{display:'inline-flex'}}> 
        <Select
          style={{width:'300px'}}
          placeholder='--- เลือก ---'
          options={car_options}
          value={data.checkcar.car_type}
          onChange={this.onCarTypeChange.bind(this)}
        />
        <SWTNewCarTypeButton
          onReload={this.onReloadCarType.bind(this)}
        />
      </div>  
    )
  }

  render(){
    let {messages,mode} = this.props
    return (
      <div>
        <Box loading={false}>
          <Box.Header>
            {this.renderDropDownCarType()}
            <Box.Tools>
              {this.renderFuelgauge()}
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <div style={{marginTop:'30px'}}>
              <Row>
                <Col md={6} sm={12}>
                  {this.renderCheckOut()}
                </Col>
                <Col md={3} sm={6}>
                  {this.renderCheckCode()}
                </Col>
                <Col md={3} sm={6}>
                  {this.renderRepairOrder()}
                </Col>
              </Row>
              <Row>
                <Col md={9}>
                  {this.renderAsset()}
                </Col>
                <Col md={3}>
                  {this.renderCheckSystem()}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {this.renderNote()}
                </Col>
              </Row>
            </div>   
          </Box.Body>
          <Box.Footer>
            <div className="pull-right">
              <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>
              &nbsp;
              <Button style={{display:mode==='account-settings'?'none':''}} className="btn btn-default"><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
            </div>
          </Box.Footer>
        </Box>  
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

// export default WorkDocCheckCarDoc = connect(
//   (state) => ({messages: state.message.view.workdoc.WorkDocCheckCarDoc}),null,null,{withRef:true}
// )(WorkDocCheckCarDoc);

WorkDocCheckCarDoc.defaultProps = {
  mode: '',
  workNo: ''
}

const _Connect = compose(connect(
  (state) => ({messages: state.message.view.workdoc.WorkDocCheckCarDoc}),null,null,{withRef:true}
))(WorkDocCheckCarDoc);

export default withRouter(_Connect) 






// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocCheckCarDoc.js